import { ActionBar, RowsSelected } from "@/components/shared/tables/ActionBar";
import { Button } from "@/components/ui/button";
import { useCostCentersDataContext } from "./cost-centers-data-provider";
import { useCostCentersTableInstanceContext } from "./table-instance-provider";

export const CostCentersActionBar = () => {
  const { table, setRowSelection } = useCostCentersTableInstanceContext();
  const { deleteCostCenters, refetch } = useCostCentersDataContext();
  const handleDelete = async () => {
    setRowSelection([]);
    await deleteCostCenters(selectedCostCenterIds);
    await refetch();
  };

  const selectedRows = table ? table.getFilteredSelectedRowModel().rows : [];
  const selectedCostCenterIds: string[] =
    selectedRows.length > 0
      ? selectedRows.map((row) => row.original?.costCenterId)
      : [];

  const allRows = table ? table.getFilteredRowModel().rows : [];

  if (selectedRows.length <= 0) return null;

  return (
    <ActionBar className="fixed bottom-4">
      <RowsSelected
        selectedRowsLength={selectedRows.length}
        totalRowsLength={allRows.length}
        onDeselectAll={() => table?.resetRowSelection(true)}
      />
      <Button variant={"outline"} onClick={() => handleDelete()}>
        Löschen
      </Button>
    </ActionBar>
  );
};
